var loadMoreProducts, products_on_page, next_url, load_more_btn, load_more_spinner;

$( document ).ready(function() {

  products_on_page = $('.products-on-page');
  next_url = products_on_page.data('next-url');
  load_more_btn = $('.load-more__btn');
  load_more_spinner = $('.load-more__spinner');

  if (next_url === "") {
    load_more_btn.hide();
  }

  loadMoreProducts = function() {

      $.ajax({
          url: next_url,
          type: 'GET',
          dataType: 'html',
          beforeSend: function () {
              load_more_btn.hide();
              load_more_spinner.show();
          }
      }).done(function (next_page) {

          load_more_spinner.hide();

          var new_products = $(next_page).find('.products-on-page');
          var new_url = new_products.data('next-url');

          if (new_url)
              load_more_btn.show();

          next_url = new_url;

          products_on_page.append(new_products.html());

      });

  }

});

